import Alpine from 'alpinejs';
import FormHandler, { GoogleV2 } from '../grit-form-handler';
import { updateMiniCart } from './cart';
import { msg } from '../main';

export const INIT_forms = () => {
  const gRecaptchaSiteKey = document
    .querySelector("meta[name='google_recaptcha_site_key']")
    .getAttribute('content');
  const forms = [
    ...document.querySelectorAll(
      '[data-form-handler]:not([name="contractor-portal-order-details"])'
    ),
  ];

  if (forms) {
    forms.forEach(form => {
      const dataAlerts = form.dataset.formAlerts;

      form.addEventListener('submit', () => {
        // Contractor portal order
        if (form.name === 'contractor-portal-order') {
          document.body.classList.add('is-loading');
        }

        // Customer portal CSV and Contractor portal CSV
        if (
          form.name === 'customer-portal-csv' ||
          form.name === 'contractor-portal-csv'
        ) {
          document.body.classList.add('is-loading');
        }

        // Admin Contractor CSV
        if (
          form.name === 'contractor-import-csv' ||
          form.name === 'assign-contractor'
        ) {
          document.querySelector('.form-container').classList.add('is-loading');
        }
      });

      new FormHandler(`#${form.id}`, {
        recaptcha: new GoogleV2(gRecaptchaSiteKey),
        flashMessage: msg,
        resetOnSuccess: form.name === 'contact' ? true : false,
        localisation: {
          success: dataAlerts.success
            ? dataAlerts.success
            : 'Thank you for your submission.',
          error: dataAlerts.error
            ? dataAlerts.error
            : 'There was an error with your submission.',
        },
        scrollToError: {
          enabled: true,
          offset: 0,
        },
        validate: {
          onChange: true,
          onSubmit: true,
        },
        onSuccess: (form, res) => {
          // Configurator
          const step = Number(form.dataset.step);
          const substep = Number(form.dataset.substep);

          if (step) {
            Alpine.store('configurator', {
              step: step,
              substep: substep,
            });

            window.history.pushState(
              {},
              '',
              `?form=configurator&step=${step}&substep=${substep}`
            );

            if (step === 4) {
              updateMiniCart();
            }
          }

          // Contractor portal order
          if (form.name === 'contractor-portal-order') {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.success, true);

            document.body.classList.remove('is-loading');

            setTimeout(() => {
              location.reload();
            }, 300);
          }

          // Customer portal CSV and Contractor portal CSV
          if (
            form.name === 'customer-portal-csv' ||
            form.name === 'contractor-portal-csv'
          ) {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.success, true);

            document.body.classList.remove('is-loading');

            setTimeout(() => {
              location.reload();
            }, 300);
          }

          // Admin Contractor CSV Import
          if (
            form.name === 'contractor-import-csv' ||
            form.name === 'assign-contractor'
          ) {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            form.querySelector('.form_messages').innerHTML =
              alertMessages.success;

            document
              .querySelector('.form-container')
              .classList.remove('is-loading');
          }

          // Contact
          if (form.name === 'contact') {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.success, true);
          }
        },
        onError: (form, res) => {
          // Contractor portal order
          if (form.name === 'contractor-portal-order') {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.error, false);

            document.body.classList.remove('is-loading');

            setTimeout(() => {
              location.reload();
            }, 300);
          }

          // Customer portal CSV and Contractor portal CSV
          if (
            form.name === 'customer-portal-csv' ||
            form.name === 'contractor-portal-csv'
          ) {
            const errors = res.errors.errors;
            let message = '';

            if (errors) {
              Object.entries(errors).forEach(([key, row]) => {
                if (row) {
                  Object.entries(row).forEach(([subkey, value]) => {
                    message += `${key}: ${value[0]}.<br />`;
                  });
                }
              });

              msg.flash(message, false);
            } else {
              const alertMessages = JSON.parse(form.dataset.formAlerts);
              msg.flash(alertMessages.error, false);
            }

            document.body.classList.remove('is-loading');
          }

          // Admin Contractor CSV Import
          if (
            form.name === 'contractor-import-csv' ||
            form.name === 'assign-contractor'
          ) {
            const errors = res.errors;
            let message = '';

            if (errors) {
              form.querySelector('.form_messages').innerHTML = errors;
            } else {
              const alertMessages = JSON.parse(form.dataset.formAlerts);
              form.querySelector('.form_messages').innerHTML =
                alertMessages.error;
            }

            document
              .querySelector('.form-container')
              .classList.remove('is-loading');
          }

          // Contact
          if (form.name === 'contact') {
            const alertMessages = JSON.parse(form.dataset.formAlerts);
            msg.flash(alertMessages.error, true);
          }
        },
      });
    });
  }

  // In-field labels
  window.addEventListener('keyup', event => {
    const target = event.target;

    if (target.dataset.infield) {
      target.setAttribute('value', target.value);
    }
  });
};
